import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { useClient } from 'jsonapi-react';
import Loader from 'app/components/loader';
import KpiWidget from './KpiWidget';
import { useSession } from 'app/hooks/useSession';
import FrequentShortcutWidget from './FrequentShortcutWidget';
import BreadCrumbs from 'app/components/BreadCrumbs';
import MetricsShortcuts from './MetricsShortcut';
import moment from 'moment';
import WallSlider from './WallSlider';
import WarningWall from './WarningWall';

function DashboardMetrics() {
  const client = useClient();
  const { session } = useSession();
  const [loading, setLoading] = useState(true);
  const [cards, setCards] = useState([]);
  const [mostVisited, setMostVisited] = useState([]);
  const [banners, setBanners] = useState();

  const getCards = async () => {
    setLoading(true);
    const { data, errors } = await client.fetch(`dashboards/kpis`);

    if (errors) {
      toast.error('Erro ao buscar informações dos cards.');
    } else {
      setCards(
        data?.data?.map((card, index) => ({
          ...card,
          id: index
        }))
      );
    }
    setLoading(false);
  };

  const getMostVisited = async () => {
    const { data, errors } = await client.fetch(`route_logs/most_visited`);

    if (errors) {
      toast.error('Erro ao buscar rotas mais acessadas.');
    } else {
      setMostVisited(data.data);
    }
  };
  const initialDate = moment().startOf('month').format('YYYY-MM-DD');
  const endDate = moment().endOf('month').format('YYYY-MM-DD');

  const fetchData = () => {
    setLoading(true);
    const fetchBanners = client.fetch(`/bulletin_boards/active`);

    let promises = [fetchBanners];

    Promise.allSettled(promises).then(([bannersResponse]) => {
      if (bannersResponse?.value?.error) {
        toast.error('Erro ao buscar banners');
      } else {
        setBanners(bannersResponse?.value?.data);
      }
      setLoading(false);
    });
  };

  useEffect(() => {
    getCards();
    getMostVisited();
    fetchData();
  }, []);

  const breadCrumbs = {
    title: 'Início',
    nav: [
      {
        route: '/',
        name: `Olá, ${session?.user?.name}`,
        isActive: true
      }
    ]
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <BreadCrumbs data={breadCrumbs} />
      {loading ? (
        <Loader />
      ) : banners?.length > 1 && !loading ? (
        <WallSlider data={banners} />
      ) : (
        !loading && (
          <WarningWall
            loading={loading}
            warning={banners?.[0]}
            key={banners?.[0]?.id}
          />
        )
      )}
      <FrequentShortcutWidget mostVisited={mostVisited} />

      <div className="kpi-widget-wrapper">
        {cards?.map(card => (
          <KpiWidget
            title={card?.label}
            count={card?.value}
            key={card?.id}
          />
        ))}
      </div>

      <div className="frequent-shortcut-widget-wrapper">
        <h3 className="frequent-shortcut-widget-wrapper__title">Relatórios mais acessados</h3>

        <div className="metrics-shortcut-wrapper">
          <MetricsShortcuts
            link="/relatorio/progresso-de-curso"
            icon="monitor"
            title="Progresso dos Cursos"
          />
          <MetricsShortcuts
            link="/relatorio/cadastro"
            icon="users"
            title="Cadastros"
          />
          <MetricsShortcuts
            link="/relatorio/funil-de-acessos"
            icon="funil"
            title="Funil de acessos"
          />
          <MetricsShortcuts
            link="/relatorio/acesso"
            icon="pointer"
            title="Mapeamento de acessos"
          />
        </div>
      </div>
    </>
  );
}

export default DashboardMetrics;
